import React, { Component } from 'react';

import LoadingContainer from '../global/Loading';
import { withScrollingView } from '../../common/WithScrollingView';
import GraphCMSComponents from '../global/GraphCMSComponents';
import { getUserDetails } from '../../store/selectors/user.selectors';
import { getProductDetails } from '../../store/selectors/product.selectors';
import { getActiveTieredSale } from '../../store/selectors/cart.selectors';
import ProductAboveTheFoldContainer from '../shopping/ProductAboveTheFold';
import paths from '../../paths';

import { default as styles } from '../../scss/pages/_plp.module.scss';
import { withCssModulesClassNames } from '../../common/nextMigrationHelpers';

import { isLoading } from '../../../../utils/Utils';

const withCssModulesClassNamesHandler = withCssModulesClassNames(styles);

export class Index extends Component {
  render() {
    const {
      components, userDetails, productDetails, url,
    } = this.props;
    const pathsWithControlledVW = [paths.TERMS, paths.TERMS__REFERRAL, paths.RETURNS, paths.ACCESSIBILITY, paths.COVID, paths.PATENTS];
    if (isLoading(this.props)) {
      return <LoadingContainer />;
    }
    if (this.props.product?.sku) {
      return (
        <div className={withCssModulesClassNamesHandler('pdp')}>
          <ProductAboveTheFoldContainer />
          <section className={withCssModulesClassNamesHandler('pdp-btf')}>
            <GraphCMSComponents
              components={components}
              history={this.props.history}
              location={this.props.location}
              userDetails={userDetails}
              productDetails={productDetails}
              tieredCoupon={this.props.tieredCoupon}
            />
          </section>
        </div>
      );
    }
    if (pathsWithControlledVW.includes(url))  {
      return   (
        <div className={withCssModulesClassNamesHandler('landing')}>
          <GraphCMSComponents
            components={components}
          />
        </div>
      );
    }
    return (
      <div className={withCssModulesClassNamesHandler('homepage')}>
        <GraphCMSComponents
          components={components}
          history={this.props.history}
          location={this.props.location}
          tieredCoupon={this.props.tieredCoupon}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  tieredCoupon: getActiveTieredSale(state),
  productDetails: getProductDetails(state),
  userDetails: getUserDetails(state),
});

export default withScrollingView(mapStateToProps, null)(Index);
